/**
 * Decide whether a poll tick observed a genuine survey-status transition that
 * warrants a PATCH back to the server.
 *
 * The key to stopping the runaway polling (TPE-2887) is that this is compared
 * against the *current* survey status - the value read from a ref on each tick -
 * rather than the `survey` captured in the interval's closure when polling
 * began. Once the store reflects the server status, `polledStatus` and
 * `currentStatus` match, this returns false, and the poll stops re-dispatching
 * `updateSurvey` on every 10s tick.
 */
export function shouldSyncPolledSurveyStatus(
  polledStatus: string | undefined,
  currentStatus: string | undefined,
): boolean {
  // Converged: server already matches what we hold - nothing to do.
  if (polledStatus === currentStatus) return false;
  // Never downgrade a locally submitted survey back to 'complete'.
  if (currentStatus === 'submittedForAssessment' && polledStatus === 'complete') return false;
  return true;
}
